import { combineReducers } from "@reduxjs/toolkit";

// Reducers
import { viewsAdminAuditTableReducer } from "./audit/tableReducer";

export const viewsAdminAuditReducer = combineReducers({
  table: viewsAdminAuditTableReducer,
});
